module.exports = __webpack_public_path__ + "img/move_pick_pockets.65fe5c2a.png";